import React from "react";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();
  return (
    <div>
      <h1
        onClick={() =>
          (window.location.href = window.location.href =
            window.location.href.split("v1")[0])
        }
      >
        Contact
      </h1>
    </div>
  );
};

export default Contact;
